'use client'
import { useState, useEffect } from 'react'
import Menu from './Menu'
import SecNav from './SecNav'
import Footer from './Footer'
import { MainContext } from 'utils/context'
import Modal from './Modal'
// import ModalMsg from './ModalMsg'
import { getMenu } from 'services/global'
import CookieConsent from 'components/CookieConsent'
import 'styles/globals.css'

const BodyLayout = ({ children }) => {
  const [menu, setMenu] = useState([])
  const [torId, setTorId] = useState()
  const [isLogged, setIsLogged] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showModalMsg, setShowModalMsg] = useState(false)
  const [fedId, setFedId] = useState(0)
  const [fedToken, setFedToken] = useState()
  const [clubId, setClubId] = useState(0)
  const [clubToken, setClubToken] = useState()

  const menuReq = async () => {
    const menuReq = await getMenu()
    setMenu(menuReq)
  }

  const setupLocalStorage = async () => {
    const _fedId = localStorage.getItem('fedId')
    setFedId(_fedId)
    const _fedToken = localStorage.getItem('fedToken')
    setFedToken(_fedToken)
    const _clubId = localStorage.getItem('clubId')
    setClubId(_clubId)
    const _clubToken = localStorage.getItem('clubToken')
    setClubToken(_clubToken)
    if ((_fedId && _fedToken) || (_clubId && _clubToken)) {
      setIsLogged(true)
    }
  }

  useEffect(() => {
    menuReq()
    setupLocalStorage()

    // Modal
    // const _showModalMsg = localStorage.getItem('showModalMsg')
    // if (_showModalMsg !== 'false') {
    //   setShowModalMsg('globalMsg')
    // }
  }, [])

  return (
    <body className="overflow-x-hidden">
      <div className="bg-white font-alliance-regular">
        {menu?.length ? (
          <Menu
            nav={menu}
            setShowModal={setShowModal}
            isLogged={isLogged}
            fedId={fedId}
            clubId={clubId}
          />
        ) : null}
        {menu?.length ? (
          <SecNav
            main={true}
            elements={['Competició', 'Circuits i Lligues']}
            items={menu}
          />
        ) : null}
        <main className="min-h-[1200px]">
          <MainContext.Provider
            value={{
              menu,
              torId,
              setTorId,
              setIsLogged,
              isLogged,
              fedId,
              fedToken,
              clubId,
              clubToken,
              setClubId,
              setClubToken,
              setShowModal,
              setShowModalMsg
            }}
          >
            {children}
          </MainContext.Provider>
        </main>
      </div>
      {showModal && (
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          setIsLogged={setIsLogged}
          setFedId={setFedId}
          setFedToken={setFedToken}
          setClubId={setClubId}
          setClubToken={setClubToken}
        />
      )}
      {/* <ModalMsg
        showModalMsg={showModalMsg}
        setShowModalMsg={setShowModalMsg}
        modalMsgText=""
        modalIcon=""
        isSmall={true}
        linkCTA=""
        textCTA=""
        actionAfterClose={() => {
          localStorage.setItem('showModalMsg', false)
        }}
      /> */}
      <CookieConsent />
      {menu?.length ? <Footer /> : null}
    </body>
  )
}

export default BodyLayout
